import { applyMiddleware, createStore } from 'redux';
import createSagaMiddleware from 'redux-saga';
import rootReducer from './reducers';
import authSaga from './sagas/auth';
import adminSaga from './sagas/admin';
import pointsSaga from './sagas/points';

export default function configureStore() {
  const sagaMiddleware = createSagaMiddleware();
  const store = createStore(rootReducer, applyMiddleware(sagaMiddleware));
  sagaMiddleware.run(authSaga);
  sagaMiddleware.run(adminSaga);
  sagaMiddleware.run(pointsSaga);
  return store;
}

export type AppStore = ReturnType<typeof configureStore>;
export type AppDispatch = AppStore['dispatch'];
